import { casesActions } from "configs";
import {
  ImageType,
  useAuth,
  useCurrentCase,
  useDispatch,
  useParams
} from "duck";
import {
  useDeleteDentalSketchCommentsMutation,
  useUpdatePatientInformationMutation
} from "requests";

export const useUpdateDentalSketch = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const [update, { loading }] = useUpdatePatientInformationMutation();

  const { shouldSync, patientId } = useCurrentCase(medicalCase => ({
    patientId: medicalCase.data.client.patient._id,
    shouldSync: medicalCase.shouldSync
  }));

  return {
    update: (dentalSketch: ImageType | null) => {
      dispatch(
        casesActions.updateDentalSketch({
          _id: id,
          data: {
            dentalSketch
          }
        })
      );

      if (shouldSync) {
        return update({
          variables: { input: { _id: patientId, dentalSketch } }
        });
      }
    },
    loading
  };
};

export const useDeleteDentalSketchComments = () => {
  const { id: caseId } = useParams();
  const dispatch = useDispatch();
  const [deleteComments] = useDeleteDentalSketchCommentsMutation({
    ignoreResults: true
  });
  const { shouldSync, dentalSketchComments } = useCurrentCase(medicalCase => ({
    dentalSketchComments: medicalCase.data.client.patient.dentalSketchComments,
    shouldSync: medicalCase.shouldSync
  }));
  const [{ user }] = useAuth();
  const ids = dentalSketchComments
    .filter(comment => comment.createdBy._id === user._id)
    .map(comment => comment._id || comment.fakeId);

  if (!ids.length) {
    return null;
  }

  return () => {
    if (shouldSync) {
      return deleteComments({
        variables: {
          input: {
            ids: ids as number[]
          }
        }
      }).then(() => {
        dispatch(
          casesActions.deleteDentalSketchComments({
            data: ids as (number | string)[],
            _id: caseId
          })
        );
      });
    }

    dispatch(
      casesActions.deleteDentalSketchComments({
        data: ids as (number | string)[],
        _id: caseId
      })
    );
  };
};
